import { UploadFail } from 'reactApp/modules/uploading/fails/UploadFail';

export class FileExistsFail extends UploadFail {
    static WEB_BACKEND_ERROR = 'file_exists';

    radarName = 'fail_{SOURCE}_file-exists';

    message = 'Файл с таким именем уже существует.';
}
